<template>
  <master-main
    :route="getModuleRoute"
    :addProperties="{
      eventType: 1,
      routeToCreate: getModuleRoute,
    }"
    :tableProperties="tableProperties"
    :exportProperties="{
      pdf: {
        filename: `${$t('inventory.supplyings')}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('inventory.supplyings')}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.farms2'),
        data: 'farms',
        property: 'name',
        minWidth: 200,
      },
      {
        columnLabel: $t('inventory.article_category'),
        data: 'article_categories',
        property: 'name',
        minWidth: 200,
      },
      {
        columnLabel: $t('inventory.articles'),
        data: 'articles',
        property: 'name',
        minWidth: 200,
      },
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 200,
      },
    ]"
    :showProperties="showProperties"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    @refresh="refresh"
  ></master-main>
</template>
<script>
import { getDateToday } from 'src/util/Util';
import i18n from 'src/i18n';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import SupplyingsTable from 'src/views/Pages/Dashboard/Supplying/Inventory/Supplying/supplyings-table';
export default {
  components: { MasterMain },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '70%' },
    };
  },
  mixins: [MixinAlert, MixinLoading, MixinMain, MixinPermissions],
  computed: {
    getModuleRoute() {
      return 'inventory/supplying';
    },
    dateToday() {
      return getDateToday();
    },
    buildTableProperties() {
      return {
        tableColumns: [...SupplyingsTable().tableColumns],
        effectTags: 'dark',
        model: 'supplying',
        addColumns: [
          {
            label: i18n.t('common_words.farms2'),
            data: 'farms',
            field: 'name',
          },
          {
            label: i18n.t('inventory.article_category'),
            data: 'article_categories',
            field: 'name',
          },
          {
            label: i18n.t('inventory.articles'),
            data: 'articles',
            field: 'name',
          },
        ],
      };
    },
  },
};
</script>
